<template>
  <md-card class="traffic-light" :class="[status, {clickable}]" @click.native="$emit('click', $event)">
    <md-card-header>
      <div class="card-icon" :class="status">
        <md-icon>{{ icon }}</md-icon>
      </div>
      <div class="md-title">{{ title }}</div>
      <div class="bannerMessage" v-if="bannerMessage" status="bad">
        {{ bannerMessage }}
      </div>
    </md-card-header>
    <md-card-content class="card-content" :class="status" v-if="sameLine">
      <slot />
    </md-card-content>
    <md-card-content class="card-content" :class="status" v-else>
      <p><slot /></p>
    </md-card-content>
    <md-tooltip :md-direction="tooltipDirection" v-if="showTooltip && (status == 'neutral' || status == 'bad')">{{ tooltip }}</md-tooltip>
  </md-card>
</template>

<script>

export default {
  props: {
    status: {
      type: String,
      default: "good",
    },
    showTooltip: {
      type: Boolean,
      default:false,
    },
    tooltip: {
      type: String,
      default: 'Attention! The indicator is not excellent.'
    },
    tooltipDirection: {
      type: String,
      default: 'top'
    },
    title: {
      type: String,
      default: "",
    },
    value: {
      type: [String,Number],
      default: "",
    },
    sub_title: {
      type: String,
      default: null,
    },
    sub_value: {
      type: [String,Number],
      default: null,
    },
    sameLine: {
      type: Boolean,
      default:true,
    },
    bannerMessage: {
      type: String,
      default: null,
    },
  },
  computed: {
    icon(){
      switch(this.status){
        case 'good':        return 'done';
        case 'neutral':     return 'priority_high';
        case 'bad':         return 'close';
        case 'information': return 'info';
        case 'greyed': return 'announcement';
        case 'blank':
        default:            return 'info';
      }
    },
    clickable(){
      return this.$listeners && this.$listeners.click;
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/theme.scss";

  .traffic-light{
    box-shadow: 0 1px 4px 0 rgb(0 0 0 / 30%) !important;
    border: 0px solid rgba(0,0,0,0.1);

    &.good        { border-color: $color-good !important; }
    &.neutral     { border-color: $color-neutral !important; }
    &.bad         { border-color: $color-bad !important; }
    &.information { border-color: $color-information !important; }
    &.greyed { border-color: $color-grey !important; }

    &.clickable{
      cursor: pointer;
    }

    & .md-title{
      line-height: 16px;
      font-size: small;
      font-weight: bold;
      color: $color-text-light;
    }

    & .card-icon {
      background-color: $color-text-light !important;
      &.good        { background-color: $color-good !important; }
      &.neutral     { background-color: $color-neutral !important; }
      &.bad         { background-color: $color-bad !important; }
      &.information { background-color: $color-information !important; }
      &.greyed { background-color: $color-grey !important; }
      &.blank       { background-color: $color-text-light !important; color: $color-text-on-dark; }
    }

    & .card-content{
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-direction: row;

      background-color: $color-text-light !important;
      &.good        { background-color: $color-good-light !important; }
      &.neutral     { background-color: $color-neutral-light !important; }
      &.bad         { background-color: $color-bad-light !important; }
      &.information { background-color: $color-information-light !important; }
      &.greyed { background-color: $color-grey !important; color: $color-text-light !important;}
      &.blank       { background-color: $color-text-light !important; color: $color-text-on-dark; }
    }

    & .bannerMessage{
      margin-top: -40px;
      height: 90%;
      background: $ausloans-red !important;
      border-radius: 10px;
      float: right;
      padding: 1px 6px 1px 6px;
      color: white;
      font-size: 10px;
      text-transform: uppercase;
    }

  }
</style>
